module.exports = __webpack_public_path__ + "img/img-tyre-size-referance.de2b835e.png";